import {
  baseScreen,
} from 'hoc';
import React from 'react';
import i18n from 'i18n-js';
import {
  useStores,
} from 'hooks';
import {
  useHistory,
  useParams,
} from 'react-router';
import * as Yup from 'yup';
import GeneralFormFields from 'src/components/GeneralFormView/types';
import GeneralFormView from 'src/components/GeneralFormView';
import {
  FormFieldsBuilder,
} from 'src/components/GeneralFormView/Utils/FormFieldsBuilder';
import {
  LanguagesKey,
} from 'src/translations/types';
import {
  Category,
} from '../categories/types';

const categoriesForm: React.FC = () => {
  const {
    backend: {
      categories,
    },
  } = useStores();
  const history = useHistory();
  const {
    id: categoryId,
  } = useParams() as any;
  return (
    <GeneralFormView<any, Category>
      title={i18n.t('CATEGORIES')}
      identifier="id"
      defaultLang=""
      otherLanguages={[]}
      formData={new FormFieldsBuilder<Category>()
        .addField('englishName', {
          type: GeneralFormFields.INPUT_FIELD,
          title: i18n.t('ENGLISH_TITLE'),
          validationSchema: Yup.string().required(i18n.t('REQUIRED_FIELD')),
          fieldOptions: {},
        })
        .addField('arabicName', {
          type: GeneralFormFields.INPUT_FIELD,
          title: i18n.t('ARABIC_TITLE'),
          validationSchema: Yup.string().required(i18n.t('REQUIRED_FIELD')),
          fieldOptions: {},
        })
        .formFields}
      isFetchSuccessful
      update={async (id, data) => {
        try {
          if (categoryId) {
            await categories.updateCategory(categoryId, {
              translations: [
                {
                  languageCode: LanguagesKey.AR,
                  title: data.arabicName,
                }, {
                  languageCode: LanguagesKey.EN,
                  title: data.englishName,
                },
              ],
            });
          }
          history.push('/help/categories');
          return Promise.resolve();
        } catch (error) {
          return Promise.reject(error);
        }
      }}
      create={async (data) => {
        try {
          await categories.create({
            translations: [
              {
                languageCode: LanguagesKey.AR,
                title: data.arabicName,
              }, {
                languageCode: LanguagesKey.EN,
                title: data.englishName,
              },
            ],
          });
          history.push('/help/categories');
          return Promise.resolve(1);
        } catch (error) {
          return Promise.reject(error);
        }
      }}
      get={async () => {
        let res: any = {};
        if (categoryId) {
          res = await categories.getOne(categoryId);
        }
        return Promise.resolve(new Category(res));
      }}
    />
  );
};

export const CategoriesForm = baseScreen(categoriesForm, {
  allowedRoles: ['ADMIN', 'NONE'],
});
